



































import { Component, Vue } from 'vue-property-decorator';
import { MemberAccountListCard } from '@/@types/Member.js';
import AccountListCard from '@/components/member/memberCommon/AccountListCard.vue';
import AccountListTable from '@/components/member/memberCommon/AccountListTable.vue';

@Component({
  components: {
    AccountListCard,
    AccountListTable,
  },
})
export default class ApplicationListBase extends Vue {
  private isCard: boolean = true;
  private isList: boolean = false;
  private accountActionList = [
    {
      icon: 'mdi-hand-heart',
      color: 'indigo',
      notDisabled: false,
      title: 'スカウト',
      message: 'スカウトを送信します',
      clickedText: 'スカウト送信済み',
    },
    {
      icon: 'mdi-laptop-chromebook',
      color: 'cyan darken-1',
      notDisabled: true,
      title: 'web面談オファー',
      message: 'web面談オファーして検討する',
      clickedText: 'web面談オファー送信済み',
    },
    {
      icon: 'mdi-heart',
      color: 'red lighten-3',
      notDisabled: true,
      title: '気になる',
      message: '気になるを送信します',
      clickedText: '気になる送信済み',
    },
  ];
    private applicationAccountList: Array<MemberAccountListCard> = [
    {
      accountName: 'セオリー太郎1',
      age: '24',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/01',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommendedFlag: false,
      deleteFlag: false,
    },
    {
      accountName: 'セオリー太郎2',
      age: '26',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/01',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommendedFlag: false,
      deleteFlag: false,
    },
    {
      accountName: 'セオリー太郎3',
      age: '27',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/01',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommendedFlag: false,
      deleteFlag: false,
    },
    {
      accountName: 'セオリー太郎4',
      age: '28',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/01',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommendedFlag: false,
      deleteFlag: false,
    },
    {
      accountName: 'セオリー太郎5',
      age: '55',
      comment: 'フロントが得意です。よろしくお願いします。',
      desiredPayment: '2000',
      desiredPaymentUnit: '時給',
      joinStartDate: '2020/04/02',
      joinEndDate: '',
      registerDate: '',
      newRegisterFlag: false,
      recommendedFlag: false,
      deleteFlag: false,
    },
  ];

  private viewIconColor(isView: boolean) {
    if (isView) {
      return '#4384f3';
    } else {
      return 'grey lighten-1';
    }
  }
}
